(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name neo.services.factory:ChampionshipCalendarPublic
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('ChampionshipCalendarPublic', ChampionshipCalendarPublic);

  function ChampionshipCalendarPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/calendar', {id: '@_id'});
  }
}());
